import React from '../../vendor/react';
import type { ReactNode } from '../../vendor/react';
import { CircleCheck, Moon, ShieldCheck, Sun } from '../../vendor/lucide-react';
import { BrandMark } from '../layout/BrandMark';
import { useTheme } from '../../hooks/useTheme';

export function AuthLayout({ eyebrow, title, description, children }: { eyebrow: string; title: string; description: string; children?: ReactNode }) {
  const { theme, toggleTheme } = useTheme();
  return (
    <div className="auth-page">
      <aside className="auth-story">
        <BrandMark />
        <div className="auth-story__content">
          <span>Una cuenta. Toda tu operación.</span>
          <h1>Tu negocio empieza ordenado desde el primer acceso.</h1>
          <p>Organización, negocio, sucursal y permisos nacen separados para que NEXO pueda crecer sin mezclar información.</p>
          <div className="auth-story__points">
            <div><CircleCheck size={18} /><span><strong>Contexto seguro</strong><small>Cada sesión trabaja en un negocio y sucursal definidos.</small></span></div>
            <div><ShieldCheck size={18} /><span><strong>Acceso por roles</strong><small>Propietario, administración y operación con permisos distintos.</small></span></div>
          </div>
        </div>
        <p className="auth-story__foot">NEXO COMERCIO · Control para tu negocio</p>
      </aside>
      <main className="auth-main">
        <button className="icon-button auth-theme" aria-label="Cambiar tema" onClick={toggleTheme}>{theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}</button>
        <section className="auth-card">
          <div className="auth-card__heading"><span>{eyebrow}</span><h2>{title}</h2><p>{description}</p></div>
          {children}
        </section>
      </main>
    </div>
  );
}
